import React, { Component } from "react";
import UploadFolderStep1 from "./subcomponents/UploadFolderStep1";
import UploadFolderStep2 from "./subcomponents/UploadFolderStep2";
import UploadFolderStep3 from "./subcomponents/UploadFolderStep3";
import UploadFolderStep4 from "./subcomponents/UploadFolderStep4";

class UploadFolderBody extends Component {
  render() {
    const { currentStep } = this.props;
    switch (currentStep) {
      case 0:
        return <UploadFolderStep1 />;
      case 1:
        return <UploadFolderStep2 />;
      case 2:
        return <UploadFolderStep3 />;
      default:
        return <UploadFolderStep4 />;
    }
  }
}
export default UploadFolderBody;
